import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./GreenBenefits.css";

const cards = [
  {
    icon: <img src="/plan.webp" alt="Efficiency" />,
    title: "STREMLINING PROCESS",
    desc: "Automate manual tasks, reduce paperwork, and simplify complex workflows, saving time and resources for all stakeholders."
  },
  {
    icon: <img src="/mobile.webp" alt="Sustainability" />,
    title: "DATA DRIVEN DECISION MAKING",
    desc: "Leverage data analytics to provide valuable insights into market trends, enabling informed decision-making."
  },
  {
    icon: <img src="/icons/data.webp" alt="Engagement" />,
    title: "ENHANCING USER EXPERIENCE",
    desc: "Build user-friendly platforms and tools that empower buyers, sellers, renters, and property managers with greater control and convenience."
  }
];

export default function GreenBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="green-benefits-section" id="benefits">
      <div className="green-benefits-top">
        <div className="green-benefits-text" data-aos="fade-right">
          <div className="green-benefits-title">
            DIGITAL ACCELERATION<br />
            <span className="green-benefits-title-blue">IN PROPERTY TECHNOLOGY</span>
          </div>
          <div className="green-benefits-desc">
            PropTech is not just a trend; it's a transformative force shaping the future of property, construction, and real estate. By embracing these advancements, you can gain a competitive edge and unlock new opportunities in this dynamic market.
          </div>
        </div>
        <div className="green-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
      <div className="green-benefits-cards">
        {cards.map((card, i) => (
          <div
            className="green-benefits-card"
            key={i}
            data-aos="fade-up"
            data-aos-delay={100 + i * 100}
          >
            <div className="green-benefits-card-icon">{card.icon}</div>
            <div className="green-benefits-card-title">{card.title}</div>
            <div className="green-benefits-card-desc">{card.desc}</div>
          </div>
        ))}
      </div>
      <div className="green-benefits-btn-row" data-aos="fade-up" data-aos-delay="500">
        <button className="green-benefits-btn">
          MORE ABOUT DIGITAL ACCELERATION
        </button>
      </div>
    </section>
  );
}